<template lang="pug">
  .edit-sub-pause.narrow-modal-body
    .icon-subscription.text-center.color-mr-purple.xs-f-xxlarge.max-at-tweak
    SectionTitle(text="Pause Subscription").app-modal-title
    .row.pause-wrap
      p.color-slate.text-center.xs-f-small.lg-f-medium.max-at-tweak {{ pauseText }}

      QtyButtonsV2(v-if="!maxedOut" :qty="pauseMonths" min-qty="1" :max-qty="maxPauseMonths" @qtyChange="onMonthUpdate(...arguments)")

      hr.color-slate-light

      .next-date
        p.color-slate.text-center.xs-f-xsmall.lg-f-small.max-at-tweak NEXT SHIPMENT
        p.text-center.xs-f-large.lg-f-xlarge.max-at-tweak {{ nextDate | moment('MMMM DD') }}

      .other-option.text-center
        button(@click="editAutoDeliveryChooseDateModal").btn-link.transparent-btn.xs-f-small.lg-f-medium.max-at-tweak.color-mr-purple Choose a new ship date

    .row
      SubmitButtons(
        submit-text="Pause"
        :submit-method="submitModal"
        :submit-disabled="savingSub"
        cancel-text="Close"
        :cancel-method="hideModal"
        :cancel-disabled="savingSub"
      )
  
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex';
  import vueSubscriptionSvc from '../../../../services/vueSubscriptionSvc';
  import SectionTitle from "../../../SectionTitle";
  import SubmitButtons from "../../../SubmitButtons";
  import QtyButtonsV2 from "../../../QtyButtonsV2";
  export default {
    name: "EditAutoDeliveryPauseModal",
    components: {
      QtyButtonsV2,
      SubmitButtons,
      SectionTitle
    },

    data() {
      return {
        pauseMonths: 1,
        maxPauseMonths: 0,
        postponeDate: null,
        postponeDates: {}
      }
    },

    mounted() {
      this.getDates();
    },

    computed: {
      ...mapState('subscriptions', [
        'savingSub',
        'subInEdit',
        'cancelData'
      ]),

      nextDate() {
        return this.$moment(this.subInEdit.next).add(this.pauseMonths, 'months');
      },

      maxedOut() {
        return this.maxPauseMonths == 0;
      },

      pauseText() {
        return this.maxedOut ? 'This is the longest we are able to pause your subscription.' : 'How long should we pause delivery for?';
      }
    },

    methods: {
      ...mapActions('subscriptions', [
        'updateSubscription',
        'editAutoDeliveryChooseDateModal'
      ]),

      ...mapActions('modal', ['hideModal']),

      ...mapMutations('subscriptions', [
        'clearSubInEdit'
      ]),

      onMonthUpdate(num) {
        this.pauseMonths = num;
      },

      getDates() {
        vueSubscriptionSvc.getSubDateOptions({
          sub_id: this.subInEdit.id
        }).then(res => {
          this.postponeDates = res.data;

          let maxSkipDate = this.$moment().add(this.postponeDates.maxSkipDays, 'days');
          while (maxSkipDate > this.$moment(this.subInEdit.next).add(this.maxPauseMonths + 1, 'month') && this.maxPauseMonths < 7) { //- while can be dangerous, fail safe at 7
            this.maxPauseMonths++;
          }
        });
      },

      submitModal() {
        let next = this.$moment(this.nextDate).format('YYYY-MM-DD');
        let payload = {
          sub_id: this.subInEdit.id,
          changes: { next: next }
        };

        this.updateSubscription(payload).then(() => {
          this.trackEvent('Cancel flow save pause', this.cancelData);
          this.clearSubInEdit();
          this.hideModal();
          this.$router.push({ name: 'subDashboard' });
        });
      }
    }
  }
</script>

<style scoped lang="stylus">
  .edit-sub-pause
    .pause-wrap
      >p
        padding 1em 0

      hr
        max-width 22em
        margin auto
        border-color color-fog-light

    .next-date
      padding-top 2em

    .other-option
      padding 1em 1em 2.6em

</style>